import { useScript } from './useScript';
import { useEffect, useState } from 'react';
import { FinixForm } from './types';
import { PaymentMethodType } from './PaymentMethodSelector';

export type FinixTokenFormState =
  | {
      status: 'idle';
    }
  | {
      status: 'loading';
    }
  | {
      status: 'ready';
      form: FinixForm;
      sessionKey: string;
    }
  | {
      status: 'error';
      error: Error;
    };

export const useFinixTokenForm = (props: {
  environment: 'sandbox' | 'live';
  paymentMethod: PaymentMethodType;
  merchantId: string;
  containerId: string;
}) => {
  const scriptStatus = useScript('https://js.finix.com/v/1/finix.js');
  const [formState, setFormState] = useState<FinixTokenFormState>({
    status: 'idle',
  });

  useEffect(() => {
    setFormState({ status: 'idle' });
  }, [props.paymentMethod]);

  useEffect(() => {
    if (scriptStatus !== 'ready') {
      return;
    }
    if (formState.status !== 'idle') {
      return;
    }

    setFormState({ status: 'loading' });

    window.Finix!.Auth(props.environment, props.merchantId, (sessionKey) => {
      const formType =
        props.paymentMethod === 'card'
          ? window.Finix!.CardTokenForm
          : window.Finix!.BankTokenForm;
      const form = formType(props.containerId, {
        showAddress: true,
        styles: {
          default: {
            padding: '0px 16px',
            border: '1px solid #ced4da',
            fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif`,
          },
        },
      });
      setFormState({
        status: 'ready',
        form,
        sessionKey,
      });
    });
  }, [
    props.containerId,
    props.environment,
    props.merchantId,
    scriptStatus,
    formState.status,
    props.paymentMethod,
  ]);

  return formState;
};
